import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarRepresentanteService } from "../services/buscarRepresentanteService";

export const useRepresentantes = (cotaUsuarioId: number | null | undefined) => {
  const [representantes, setRepresentante] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as assinaturas
  useEffect(() => {
    
    const fetchRepresentantes = async () => {
      const data = await buscarRepresentanteService(cotaUsuarioId);

      setRepresentante(data);
      setIsLoading(false);
    };

    fetchRepresentantes();
  }, [cotaUsuarioId]);

  return { representantes, isLoading };
};
